import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { DonationCategoryService } from '../../../../../app/shared/API-Service/services/donation-category.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-view-donation-category',
  templateUrl: './view-donation-category.component.html',
  styleUrls: ['./view-donation-category.component.css']
})
export class ViewDonationCategoryComponent implements OnInit {
  Donation_categories:object [] = [];
  constructor(private _DonationCategoryService:DonationCategoryService, private _Router:Router) { }

  ngOnInit(): void {
    this.getdonationcategories();
  }


  getdonationcategories(){
    this._DonationCategoryService.GetDonationCategory().subscribe((res) => {
      this.Donation_categories = res.data
    console.log(this. Donation_categories);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
update(data){
    this._DonationCategoryService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertDonationCategory']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._DonationCategoryService.DeleteDonationCategory(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getdonationcategories();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
    
}
